window.ChartUi = class {
	constructor(options = {}) {
		this.options = options;
		google.charts.load('current', { 'packages' : ['corechart'] });
	};

	draw(target, stats_data, start, end, title = '' ) {
		let self = this;
		return new Promise(async (resolve, reject) => {
			google.setOnLoadCallback(function() {

				var len = stats_data.label.length;
				var stats = self.fill(stats_data, start, end);

				self.ticks = [];
				var steps = 18;

				if (stats.length <= 180) steps = 9;
				if (stats.length <= 30) steps = 2;
				if (stats.length <= 7) steps = 1;
				var step = steps - 1;
				
				// Armar tooltip
				// Recorrer todo el array de data
				for (var i = 0; i < stats.length; i++) {
					
					step++;
					if (step == steps) {
						if (stats[i]) {
							self.ticks.push({ "v": stats[i][0], "f": moment(stats[i][0]*1000).format('MMM DD') });
						}
						step = 0;
					}
				}

				self.data = new google.visualization.DataTable();
				self.data.addColumn('number', 'date');
				self.data.addColumn({'type': 'string', 'role': 'tooltip', 'p': {'html': true}});
				for(var i = 0; i < len; i++)
					self.data.addColumn('number', stats_data.label[i]);
				self.data.addRows(stats);

				self.graph = new google.visualization.AreaChart( $(target)[0] );

				resolve();

			});
		});
	}

	redraw() {
		let self = this;

		if($('html').hasClass('theme-dark') || $('html').hasClass('theme-auto') && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
			var $primary = '#242526FF';
			var $secondary = '#18191A70';
		}
		else {
			var $primary = '#FFFFFFFF';
			var $secondary = '#F0F2F570';
		}
		
		self.graph_options = {
			pointSize: 0,
			focusTarget: 'category',
			tooltip: {
				isHtml: true
			},
			backgroundColor: $primary,
			height: '300',
			legend: { position: 'none' },
			chartArea: {
				left:'10%',
				width:'90%',
			},
			series: {
				0: {
					color: '#058DC7',
					lineWidth: 3,
					areaOpacity: 0.1,
				},
				1: {
					color: '#FF7700',
					lineWidth: 3,
					areaOpacity: 0.1,
				},
				2: {
					color: '#7DBF5F',
					lineWidth: 3,
					areaOpacity: 0.1,
				},
			},
			hAxis: { 
				gridlines: {
					color: $secondary,
				},
				textStyle: {
					color: '#8C8C8C',
					fontName: 'Calibri',
					fontSize: 13,
				},
			},
			vAxis: {
				minValue: 0,
				gridlines: {
					color: $secondary,
				},
				textStyle: {
					color: '#8C8C8C',
					fontName: 'Calibri',
					fontSize: 12,
				},
			},
		};
		self.graph_options.hAxis.ticks = self.ticks;
		self.graph.draw(self.data, self.graph_options);
	}

	fill(stats_data, start, end) {
		let self = this;

		end = moment(end).utc().endOf('day');
		start = moment(start).utc().endOf('day');

		// let days = n * 86400;
		let rs = [];
		let index = 0;

		let data = stats_data.data;
		let size = stats_data.label.length;

		for( var date = start; date <= end; date.add(1, 'day') ) {
			var dateformat = date.format('YYYY-MM-DD')
			rs[index] = Array(size + 2).fill(0);
			rs[index][0] = date.unix();
			rs[index][1] = self.options.tooltip(stats_data.label, rs[index][0], data[dateformat]? data[dateformat] : Array(size).fill(0));

			for(var i = 0; i < size; i++) {
				if( data[dateformat] && data[dateformat][i] ) {
					rs[index][i+2] = data[dateformat][i];
				}
			}
			index++;
		}

		return rs;
	};

}